import {createContext, useReducer} from "react";

export const TableContext = createContext();

const initData = {
    //DatePicker
    dateRange: Array(new Date(new Date().setMonth(new Date().getMonth() -6)), new Date()),

    //검색 조건
    mainCode: "",
    subCode: "",

    //선택된 검색 조건
    selectedMain: "",
    selectedSub: "",
}

export const TableStateType = {
    DATE_RANGE: 'UPDATE_DATE_RANGE',
    MAIN_CODE: 'UPDATE_MAIN_CODE',
    SUB_CODE: 'UPDATE_SUB_CODE',
    SELECTED_MAIN: 'UPDATE_SELECTED_MAIN_CODE',
    SELECTED_SUB: 'UPDATE_SELECTED_SUB_CODE'
}

const reducer = (state, action) => {
    switch (action.type) {
        case TableStateType.DATE_RANGE: {
            return { ...state, dateRange: action.data }
        }
        case TableStateType.MAIN_CODE: {
            return { ...state, mainCode: action.data }
        }
        case TableStateType.SUB_CODE: {
            return { ...state, subCode: action.data }
        }
        case TableStateType.SELECTED_MAIN: {
            return { ...state, selectedMain: action.data }
        }
        case TableStateType.SELECTED_SUB: {
            return { ...state, selectedSub: action.data }
        }
    }
}

const TableProvider = ({children}) => {
    const [data, testDispatch] = useReducer(reducer, initData);

    const value = {
        state: {data},
        actions: {contextDispatch: testDispatch}
    }

    return (
        <TableContext.Provider value={value}>
            {children}
        </TableContext.Provider>
    )
}

export default TableProvider;